import styled from 'styled-components';

export const SectionInfoContainer = styled.div`
  background-color: ${({ theme }) => theme.color.secondaryBackground};
  color: ${({ theme }) => theme.color.primaryText};
  padding: 1rem 1.25rem;
  margin-top: 20px;
  display: flex;
  flex-wrap: wrap;
  gap: 0 1rem;
  align-items: stretch;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 0;
  }
`;

export const SectionInfoItem = styled.div`
  color: ${({ theme }) => theme.color.primaryText};
  flex: 1 1 0;
  min-width: 0;
  text-align: left;
  display: flex;
  align-items: flex-start;

  &:not(:first-child) {
    border-left: 1px solid ${({ theme }) => theme.color.borderColor};
    padding-left: 1rem;
  }

  @media (max-width: 768px) {
    flex: 1 1 100%;
    width: 100%;
    border-left: none !important;
    padding-left: 0 !important;
    padding-right: 0;
    padding-bottom: 1rem;
    margin-bottom: 1rem;

    &:not(:last-child) {
      border-bottom: 1px solid ${({ theme }) => theme.color.borderColor};
    }

    &:last-child {
      padding-bottom: 0;
      margin-bottom: 0;
    }
  }
`;

export const SectionInfoValue = styled.span`
  display: block;
  width: 100%;
  min-width: 0;
  white-space: pre-wrap;
  font-size: 0.9375rem;
`;
